import React, { useEffect } from 'react';
import { Trial } from '~/common/pages/Trial/Trial';
import { MODAL_TYPES } from '~/common/consts';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';

const Unified = () => {
  useEffect(() => {
    window.LPFormData.formType = 'Trial';
    window.LPFormData.contentId = '9AE89FD4-728F-4452-AFD4-15B1F8387CB4';
  }, []);

  return (
    <TrialContentProvider>
      <Trial modalType={MODAL_TYPES.UNIFIED} />
    </TrialContentProvider>
  );
};

export default Unified;
